import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  EmailValidator,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { finalize } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Constant } from 'src/app/services/auth/Constant';
import { emailValidator } from 'src/app/shared/validators/email.validator';
import * as alertify from 'alertifyjs';
import { Router } from '@angular/router';
import { ThemeService } from 'src/app/services/theme-service/theme.service';
import { MatDialog } from '@angular/material/dialog';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],   
  standalone: false,
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  errorMessage: string;
  loginInProgress: boolean;
  showPassword: boolean = false;

  showCaptcha: boolean = false;
  captchaPassed: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private themeService: ThemeService,
    private matDialog: MatDialog
  ) { }

  ngOnInit(): void {

    this.initForm();

    localStorage.removeItem(Constant.TEMP_LOGGED_IN_USER);

    sessionStorage.setItem('firstLoad', 'false');

    this.loginForm.valueChanges.subscribe(() => {
      this.errorMessage = null;
    });
  }

  initForm() {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, emailValidator()]],
      password: ['', [Validators.required]],
      rememberMe: [false],
      togglePassword: [null],
    });
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  handleCaptcha(result: boolean) {
    this.captchaPassed = result;
    this.showCaptcha = false;

    if (result) {
      this.submitForm();
    }
  }

  attemptLogin() {
    this.errorMessage = null;
    if (this.loginForm.valid) {
      this.showCaptcha = true;
    }
  }


  forgotPassword() {
    this.matDialog.open(ForgotPasswordComponent, {
      width: '380px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'operation-modal', 'modal-no-overflow-changed'],
      data: { email: this.loginForm.value?.email }
    })

  }

  togglePassword() {
    var passwordInput = document.getElementById('password') as HTMLInputElement;
    var togglePassword = this.loginForm.controls['togglePassword'].value;

    if (togglePassword === true) {
      passwordInput.type = 'text';
      this.showPassword = true;
    } else {
      passwordInput.type = 'password';
      this.showPassword = false;
    }
  }

  submitForm() {
    this.loginInProgress = true;
    this.errorMessage = null;

    const loginRequest: any = {
      username: this.loginForm.get('email')?.value,
      password: this.loginForm.get('password')?.value,
    };

    const rememberMe = this.loginForm.get('rememberMe')?.value;

    this.authService
      .login(loginRequest, rememberMe)
      .pipe(
        finalize(() => {
          this.loginInProgress = false;
        })
      )
      .subscribe({
        next: (response) => {
          if (response.token != null) {


            if (response.firstTimeLogin) {
              localStorage.setItem(Constant.TEMP_LOGGED_IN_USER, response.token);
              this.router.navigate(["/create-password"])
            } else {


              if (response.lgaSettings) {
                this.themeService.setTheme(response.lgaSettings); // Apply theme
              }

              switch (response?.role) {
                case "ADMIN":
                case "CHAIRMAN_LGA":
                case "LGA_APPROVING_ADMIN":
                case "SUPER_ADMIN":
                  this.router.navigate(["/admin/dashboard"]);
                  break;


                case "LGA_ADMIN":
                  this.router.navigate(["/admin/igr-assessment"]);
                  break;
                case "SUPER_AGENT":
                  this.router.navigate(["/user/transaction-history"]);
                  break;

                default:
                  this.router.navigate(["/401"]);
                  return;
              }

              alertify.success(response.message || 'Logged in successfully.');

              localStorage.setItem(Constant.LOGGED_IN_USER, response.token);
              localStorage.setItem(Constant.USER_DATA, JSON.stringify(response));
              this.authService.userSubject.next(response);
            }

          }
        },
        error: (err) => {
          this.errorMessage = err.message;
        },
      });
  }
}
